import {useEffect} from 'react'
import {useAuth} from '../app/modules/auth'
import {useCookieConsent} from '../app/context/CookieConsentContext'
import {applyCookieConsent, clearAllAppCookies, UserCookieData} from '../Utils/cookieManager'

/**
 * Syncs cookie data whenever the user logs in or consent changes.
 * Mount once near the top of the app tree.
 */
export function useCookieSync() {
  const {currentUser, auth} = useAuth()
  const {consentGiven, consentLevel} = useCookieConsent()

  useEffect(() => {
    if (!consentGiven || !consentLevel) return

    if (currentUser?.result && auth?.token) {
      const userData: UserCookieData = {
        userType: currentUser.result.userType,
        email: currentUser.result.email,
        firstName: currentUser.result.firstName,
        lastName: currentUser.result.lastName,
        userId: currentUser.result.code,
        authToken: auth.token,
        awsUserId: currentUser.result.awsUserId,
        awsConnectToken: currentUser.result.awsConnectToken,
        timezone: currentUser.result.defaultTimeZone,
      }
      applyCookieConsent(consentLevel, userData)
    } else {
      applyCookieConsent(consentLevel)
    }
  }, [consentGiven, consentLevel, currentUser, auth])

  useEffect(() => {
    if (!currentUser && !auth) {
      clearAllAppCookies()
    }
  }, [currentUser, auth])
}
